import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import DashboardContent from "./components/DashboardContent";
import DashboardSetting from "./components/DashboadSetting";
import Footer from "../../../../components/Footer";
import { getAllAdminUsers } from "../../../../services/api/fytnServices";

const DashboardNew = ({ userData }) => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [adminUsers, setAdminUsers] = useState([]);

  const fetchAdminAllUsers = async () => {
    try {
      const response = await getAllAdminUsers();
      const users = response?.data?.data?.data || [];
      
      // Sort users: active users first, then by creation date
      const sortedUsers = users.sort((a, b) => {
        // First priority: Active users (STATUS === 'ACTIVE')
        const aActive = a.STATUS === 'ACTIVE';
        const bActive = b.STATUS === 'ACTIVE';
        
        if (aActive !== bActive) {
          return aActive ? -1 : 1; // Active users first
        }
        
        // Second priority: Sort by creation date (newest first)
        const aDate = new Date(a.CREATED_AT || 0);
        const bDate = new Date(b.CREATED_AT || 0);
        return bDate - aDate;
      });
      
      setAdminUsers(sortedUsers);
    } catch (err) {
      console.error("Error in fetching data");
    }
  };

  useEffect(() => {
    fetchAdminAllUsers();
  }, [activeTab]);

  return (
    <>
      <Box sx={{ width: "100%" }}>
        {activeTab === "dashboard" ? (
          <DashboardContent
            adminUsers={adminUsers}
            fetchAdminAllUsers={fetchAdminAllUsers}
          />
        ) : (
          <DashboardSetting />
        )}
      </Box>
      <Footer />
    </>
  );
};

export default DashboardNew;
